export const hasEndedSwipeAndMustStay = (prevState, state) =>
  prevState.isTransitioning &&
  !state.isTransitioning &&
  prevState.isSwiping &&
  state.isSwiping;

export const hasEndedSwipeAndMustContinue = (prevState, state) =>
  prevState.isTransitioning && !state.isTransitioning && !state.isSwiping;

export const hasEndedNavigation = (prevState, state) =>
  prevState.enteringItemIndex === null &&
  state.enteringItemIndex !== null &&
  !state.isSwiping;

export default {
  hasEndedSwipeAndMustStay,
  hasEndedSwipeAndMustContinue,
  hasEndedNavigation
};
